export default function (donationsService) {
  let vm;

  class DonationsProgressController {
    constructor () {
      vm = this;
      vm.donationsService = donationsService;
    }
  }

  return new DonationsProgressController();
}



// WEBPACK FOOTER //
// ./client/app/components/donations-progress/donations-progress.controller.js